import React, { useContext } from 'react';
import { useApi } from '../useAPI';
import { UserContext } from '../UserContext';
import LoadingSpinner from '../loadingspinner';

const MeScores = () => {
  const { setUserData, userData } = useContext(UserContext);
  const { lookupScore, updateUserData } = useApi();
  const lookupScoreData = userData?.lookupScoreData || [];


  const setLookupNickname = (e) => {
    const updatedNickname = e.target.value;
    setUserData((prevData) => ({
      ...prevData,
      lookupScore: {
        ...prevData.lookupScore,
        nickname: updatedNickname,
        login: userData.player.login
      },
    }));
  };
  const setLookupTime = (e) => {
    const updatedTime = e.target.value;
    setUserData((prevData) => ({
      ...prevData,
      lookupScore: {
        ...prevData.lookupScore,
        time: updatedTime,
        login: userData.player.login
      },
    }));
  };
  const setLookupClan = (e) => {
    const updatedClan = e.target.value;
    setUserData((prevData) => ({
      ...prevData,
      lookupScore: {
        ...prevData.lookupScore,
        clan: updatedClan,
        login: userData.player.login
      },
    }));
  };

  const handleSubmit = async (e) => {
    if (e != null) {
      e.preventDefault();
    }
    const result = await lookupScore(userData?.lookupScore?.id, 
      userData.player.login, 
      userData?.lookupScore?.nickname || '', 
      '', 
      userData?.lookupScore?.time || '', 
      userData?.lookupScore?.clan || '', 
      userData?.lookupScore?.orderup || '', 
      userData?.lookupScore?.orderdown || 'id');

    if (!result.success) {
      console.error('lookupScore failed:', result.error || result.status);
    }
  };

  const sortUp = async (column) => {
    const result = await lookupScore(userData?.lookupScore?.id || '', 
      userData.player.login, 
      userData?.lookupScore?.nickname || '', 
      '', 
      userData?.lookupScore?.time || '', 
      userData?.lookupScore?.clan || '', 
      column, 
      '');

    if (!result.success) {
      console.error('lookupScore failed:', result.error || result.status);
    }
  };
  
  const sortDown = async (column) => {
    const result = await lookupScore(userData?.lookupScore?.id || '', 
      userData.player.login, 
      userData?.lookupScore?.nickname || '', 
      '', 
      userData?.lookupScore?.time || '', 
      userData?.lookupScore?.clan || '', 
      '', 
      column);

    if (!result.success) {
      console.error('lookupScore failed:', result.error || result.status);
    }
  };

  const doClear = async () => {
    const result = await lookupScore('', 
      userData.player.login, 
      '', 
      '', 
      '', 
      '', 
      '', 
      'id');

    if (!result.success) {
      console.error('lookupScore failed:', result.error || result.status);
    }
  };

  const lookupUserByLoginID= async (id) => {
    var slimData = lookupScoreData.filter(item => item.id === id);
    if (slimData.length === 1) {
        updateUserData({ lookupScoreData: slimData });
        return;
    }

    const result = await lookupScore(id, 
      userData.player.login,
      '', 
      '', 
      '', 
      '', 
      '', 
      '');

    if (!result.success) {
      console.error('lookupScore failed:', result.error || result.status);
    }
  };
  
  return (
    <div>
      <h1>{userData.gameInfo.gameDisplayName} Scores Lookup</h1>

      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <button
            type="submit"
            className="refresh-button"
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(76, 175, 80, 1)';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(76, 175, 80, 0.7)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            Refresh
          </button>
          <input
            type="text"
            name="lookupNickname"
            placeholder="Nickname"
            value={userData?.lookupScore?.nickname || ''}
            onChange={setLookupNickname}
            className="input-field"
          />
          <input
            type="text"
            name="lookupTime"
            placeholder="time"
            value={userData?.lookupScore?.time || ''}
            onChange={setLookupTime}
            className="input-field"
          />
          <input
            type="text"
            name="lookupClan"
            placeholder="clan"
            value={userData?.lookupScore?.clan || ''}
            onChange={setLookupClan}
            className="input-field"
          />
          <button
            className="refresh-button"
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(76, 175, 80, 1)';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(76, 175, 80, 0.7)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
            onClick={() => doClear()}
          >
            Clear
          </button>
        </form>
      </div>

      {userData.busy ? (
        <LoadingSpinner />
      ) : Array.isArray(lookupScoreData) && lookupScoreData.length > 0 ? (
        lookupScoreData.length === 1 ? (
          <SingleScoreTable rec={lookupScoreData[0]}/>
        ) : (
          <div className="table-container">
            <table id="matches">
              <thead>
                <tr>
                    <th>
                      ID
                      <span
                        style={{ 
                          cursor: 'pointer',
                          color: userData?.lookupScore?.orderup === 'id' ? 'black' : 'inherit',
                        }}
                        onClick={() => sortUp('id')}
                      >
                        &#9650;
                      </span>
                      <span
                        style={{ 
                          cursor: 'pointer',
                          color: userData?.lookupScore?.orderdown === 'id' ? 'black' : 'inherit',
                        }}
                        onClick={() => sortDown('id')}
                      >
                        &#9660;
                      </span>
                    </th>
                    <th>Time</th>
                    <th>
                      Nickname 
                      <span
                        style={{ 
                          cursor: 'pointer',
                          color: userData?.lookupScore?.orderup === 'nickname' ? 'black' : 'inherit',
                        }}                        
                        onClick={() => sortUp('nickname')}
                      >
                        &#9650;
                      </span>
                      <span
                        style={{ 
                          cursor: 'pointer',
                          color: userData?.lookupScore?.orderdown === 'nickname' ? 'black' : 'inherit',
                        }}                        
                        onClick={() => sortDown('nickname')}
                      >
                        &#9660;
                      </span>
                    </th>
                    <th>
                      Experience
                      <span
                        style={{ 
                          cursor: 'pointer',
                          color: userData?.lookupScore?.orderup === 'xp' ? 'black' : 'inherit',
                        }}                        
                        onClick={() => sortUp('xp')}
                      >
                        &#9650;
                      </span>
                      <span
                        style={{ 
                          cursor: 'pointer',
                          color: userData?.lookupScore?.orderdown === 'xp' ? 'black' : 'inherit',
                        }}                        
                        onClick={() => sortDown('xp')}
                      >
                        &#9660;
                      </span>
                    </th>
                    <th>
                      Clan
                      <span
                        style={{ 
                          cursor: 'pointer',
                          color: userData?.lookupScore?.orderup === 'clan' ? 'black' : 'inherit',
                        }}                        
                        onClick={() => sortUp('clan')}
                      >
                        &#9650;
                      </span>
                      <span
                        style={{ 
                          cursor: 'pointer',
                          color: userData?.lookupScore?.orderdown === 'clan' ? 'black' : 'inherit',
                        }}                        
                        onClick={() => sortDown('clan')}
                      >
                        &#9660;
                      </span>
                    </th>
                      {(userData.gameInfo.gameID === 'TankOff Classic') && (<th>Kills</th>)}
                      {(userData.gameInfo.gameID === 'TankOff Classic') && (<th>Flags</th>)}
                </tr>
              </thead>
              <tbody>
                {lookupScoreData.map((rec, index) => (
                  <tr key={index}>
                    <td>
                      {rec.id}
                      <span
                        className="nickname-hover"
                        onClick={() => lookupUserByLoginID(rec.id)}
                      >
                        <img src="/portal/images/search_login16.png" alt="lookup login"/>  
                      </span>
                    </td>
                    <td>{rec.time}</td>
                    <td>
                      {rec.nickname}
                    </td>
                    <td>{rec.experience.toLocaleString()}</td>
                    <td>
                      {rec.clan}
                    </td>
                    {(userData.gameInfo.gameID === 'TankOff Classic') && (<td>{rec.kills}</td>)}
                    {(userData.gameInfo.gameID === 'TankOff Classic') && (<td>{rec.flags}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      ) : (
        <div>No scores to display</div>
      )}
    </div>
  );
};

const SingleScoreTable = ({ rec }) => {
  const { userData } = useContext(UserContext);
  return (
    <>
  <table>
    <tr>
      <th>ID</th>
      <td>SCORE#{rec.id}</td>
    </tr>
    <tr>
      <th>Time</th>
      <td>{rec.time}</td>
    </tr>
    <tr>
      <th>Nickname</th>
      <td>
        {rec.nickname}
      </td>
    </tr>
    <tr>
      <th>Old Nickname</th>
      <td>
        {rec.nicknameOld}
      </td>
    </tr>
    <tr>
      <th>Experience</th>
      <td>{rec.experience.toLocaleString()}</td>
    </tr>
    {(userData.gameInfo.gameID === 'TankOff Classic') && (<>
    <tr>
      <th>Kills</th>
      <td>{rec.kills}</td>
    </tr>
    <tr>
      <th>Flags</th>
      <td>{rec.flags}</td>
    </tr>
    </>)}
    <tr>
      <th>Old Experience</th>
      <td>{rec.experienceOld.toLocaleString()}</td>
    </tr>
    <tr>
      <th>New Experience</th>
      <td>{rec.experienceNew.toLocaleString()}</td>
    </tr>
    {(userData.gameInfo.gameID === 'TankOff Classic') && (<>
    <tr>
      <th>Distance Traveled</th>
      <td>{rec.metadata.mDist}</td>
    </tr>
    <tr>
      <th>Maximum Speed</th>
      <td>{rec.metadata.mMaxSpd}</td>
    </tr>
    <tr>
      <th>Deaths</th>
      <td>{rec.metadata.mDeaths}</td>
    </tr>
    <tr>
      <th>Damage Dealt</th>
      <td>{rec.metadata.mDmgDealt}</td>
    </tr>
    <tr>
      <th>Damage Taken</th>
      <td>{rec.metadata.mDmgTaken}</td>
    </tr>
    <tr>
      <th>Team</th>
      <td>{rec.metadata.team}</td>
    </tr>
    <tr>
      <th>Room</th>
      <td>{rec.room}</td>
    </tr>
    <tr>
      <th>Upgrades</th>
      <td>{rec.upgrades}</td>
    </tr>
    </>)}
    <tr>
      <th>Status</th>
      <td>
        {rec.status}
      </td>
    </tr>
  </table>
  </>
  );
};

export default MeScores;
